 /* eslint-disable */
 import isString from '@dcode/is/string/string';
 import clamp from '~/utils/number/clamp';

 export const data = {
	 covers:
	 {
		 mobile:
		 [
			 {
				 name: 'work',
				 text: 'La Fiat Strada que conocés se renovó como nunca para superarse.',
				 label: 'REINVENTE<br/>LA RUTINA',
				 caption: 'FIAT STRADA',
				 src: '/assets/images/mobile/cover-work.jpg',
			 },
			 {
				 name: 'play',
				 text: 'La Fiat Strada que conocés se renovó como nunca para superarse.',
				 label: 'REINVENTE<br/> SUPERARSE',
				 caption: 'FIAT STRADA',
				 src: '/assets/images/mobile/cover-play.jpg',
			 },
		 ],
		 desktop:
		 [
			 {
				 name: 'work',
				 text: 'La Fiat Strada que conocés se renovó como nunca para superarse.',
				 label: 'REINVENTE<br/>LA RUTINA',
				 caption: 'FIAT STRADA',
				 src: '/assets/images/desktop/cover-work.jpg',
			 },
			 {
				 name: 'play',
				 text: 'La Fiat Strada que conocés se renovó como nunca para superarse.',
				 label: 'REINVENTE<br/> SUPERARSE',
				 caption: 'FIAT STRADA',
				 src: '/assets/images/desktop/cover-play.jpg',
			 },
		 ],
	 },
	 features:
	 [
		 {
			 id: '#index',
			 path: '/capacidad-de-carga',
			 title: 'CAPA-<br/>CIDAD<br/>DE CARGA',
			 modal:
			 [
				 {
					 thumbnail: '/assets/images/main-page/modal/desk/capacidade-de-carga.jpg',
				 	 tabName: 'aba 1',
					 caption: 'CAPACIDAD<br/>DE CARGA',
					 title: 'LLEVÁ CON VOS TODO LO QUE QUERÉS',
					 description: 'La Fiat Strada incrementa su capacidad de carga. La <span>cabina plus</span> ofrece una caja de <span>1.354 litros</span> de volumen y <span>720kg</span> de capacidad de carga.<br> Las versiones cabina doble, además de transportar más pasajeros, poseen una caja de <span>844 litros</span> de volumen y <span>650kg</span> de carga. <span>La mayor capacidad volumétrica de su segmento.</span>',
					 descriptionMobile: 'La Fiat Strada incrementa su capacidad de carga. La <span>cabina plus</span> ofrece una caja de <span>1.354 litros</span> de volumen y <span>720kg</span> de capacidad de carga.<br> Las versiones cabina doble, además de transportar más pasajeros, poseen una caja de <span>844 litros</span> de volumen y <span>650kg</span> de carga. <span>La mayor capacidad volumétrica de su segmento.</span>',
					 poster:
					 {
						 alt: '',
						 sources: [
					 		 {
								 media: '(max-width: 1024px) and (orientation: portrait)',
								 srcSet: '/assets/images/main-page/modal/mobile/capacidade-de-carga.jpg',
							 },
							 {
								 media: '(orientation: landscape)',
								 srcSet: '/assets/images/main-page/modal/desk/capacidade-de-carga.jpg',
							 },
							 {
								 media: '(min-width: 1025px) and (orientation: landscape)',
								 srcSet: '/assets/images/main-page/modal/desk/capacidade-de-carga.jpg',
							 },
						 ],
					 },
				 },
				 {
					 thumbnail: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-2.jpg',
					 tabName: 'aba 1',
					 caption: 'CAPACIDAD<br/>DE CARGA',
					 title: 'LLEVÁ CON VOS TODO LO QUE QUERÉS',
					 description: 'La Fiat Strada incrementa su capacidad de carga. La <span>cabina plus</span> ofrece una caja de <span>1.354 litros</span> de volumen y <span>720kg</span> de capacidad de carga.<br> Las versiones cabina doble, además de transportar más pasajeros, poseen una caja de <span>844 litros</span> de volumen y <span>650kg</span> de carga. <span>La mayor capacidad volumétrica de su segmento.</span>',
					 descriptionMobile: 'La Fiat Strada incrementa su capacidad de carga. La <span>cabina plus</span> ofrece una caja de <span>1.354 litros</span> de volumen y <span>720kg</span> de capacidad de carga.<br> Las versiones cabina doble, además de transportar más pasajeros, poseen una caja de <span>844 litros</span> de volumen y <span>650kg</span> de carga. <span>La mayor capacidad volumétrica de su segmento.</span>',
					 poster:
					 {
						 alt: '',
						 sources: [
					 		 {
								 media: '(max-width: 1024px) and (orientation: portrait)',
								 srcSet: '/assets/images/main-page/modal/mobile/capacidade-de-carga-2.jpg',
							 },
							 {
								 media: '(orientation: landscape)',
								 srcSet: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-2.jpg',
							 },
							 {
								 media: '(min-width: 1025px) and (orientation: landscape)',
								 srcSet: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-2.jpg',
							 },
						 ],
					 },
				 },
				 {
					thumbnail: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-3.jpg',
					 tabName: 'aba 1',
					 caption: 'CAPACIDAD<br/>DE CARGA',
					 title: 'LLEVÁ CON VOS TODO LO QUE QUERÉS',
					 description: 'La Fiat Strada incrementa su capacidad de carga. La <span>cabina plus</span> ofrece una caja de <span>1.354 litros</span> de volumen y <span>720kg</span> de capacidad de carga.<br> Las versiones cabina doble, además de transportar más pasajeros, poseen una caja de <span>844 litros</span> de volumen y <span>650kg</span> de carga. <span>La mayor capacidad volumétrica de su segmento.</span>',
					 descriptionMobile: 'La Fiat Strada incrementa su capacidad de carga. La <span>cabina plus</span> ofrece una caja de <span>1.354 litros</span> de volumen y <span>720kg</span> de capacidad de carga.<br> Las versiones cabina doble, además de transportar más pasajeros, poseen una caja de <span>844 litros</span> de volumen y <span>650kg</span> de carga. <span>La mayor capacidad volumétrica de su segmento.</span>',
					 poster:
					 {
						 alt: '',
						 sources: [
					 		 {
								 media: '(max-width: 1024px) and (orientation: portrait)',
								 srcSet: '/assets/images/main-page/modal/mobile/capacidade-de-carga-3.jpg',
							 },
							 {
								 media: '(orientation: landscape)',
								 srcSet: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-3.jpg',
							 },
							 {
								 media: '(min-width: 1025px) and (orientation: landscape)',
								 srcSet: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-3.jpg',
							 },
						 ],
					 },
				 },
				 {
					thumbnail: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-4.jpg',
					 tabName: 'aba 1',
					 caption: 'CAPACIDAD<br/>DE CARGA',
					 title: 'LLEVÁ CON VOS TODO LO QUE QUERÉS',
					 description: 'La Fiat Strada incrementa su capacidad de carga. La <span>cabina plus</span> ofrece una caja de <span>1.354 litros</span> de volumen y <span>720kg</span> de capacidad de carga.<br> Las versiones cabina doble, además de transportar más pasajeros, poseen una caja de <span>844 litros</span> de volumen y <span>650kg</span> de carga. <span>La mayor capacidad volumétrica de su segmento.</span>',
					 descriptionMobile: 'La Fiat Strada incrementa su capacidad de carga. La <span>cabina plus</span> ofrece una caja de <span>1.354 litros</span> de volumen y <span>720kg</span> de capacidad de carga.<br> Las versiones cabina doble, además de transportar más pasajeros, poseen una caja de <span>844 litros</span> de volumen y <span>650kg</span> de carga. <span>La mayor capacidad volumétrica de su segmento.</span>',
					 poster:
					 {
						 alt: '',
						 sources: [
					 		 {
								 media: '(max-width: 1024px) and (orientation: portrait)',
								 srcSet: '/assets/images/main-page/modal/mobile/capacidade-de-carga-4.jpg',
							 },
							 {
								 media: '(orientation: landscape)',
								 srcSet: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-4.jpg',
							 },
							 {
								 media: '(min-width: 1025px) and (orientation: landscape)',
								 srcSet: '/assets/images/main-page/gallery/capacidade-de-carga/imagem-4.jpg',
							 },
						 ],
					 },
				 },
			 ],
			 thumb: {
				 alt: 'capacidad de carga',
				 src: '/assets/images/main-page/thumbs/capacidade-de-carga.jpg',
				 srcSet: ['/assets/images/main-page/thumbs/capacidade-de-carga.jpg', '/assets/images/main-page/thumbs/capacidade-de-carga.jpg', '/assets/images/main-page/thumbs/capacidade-de-carga.jpg'],
			 },
		 },
		 {
			 id: '#index',
			 path: '/robustez',
			 title: 'ROBUSTEZ<br>Y CON-<br>FIANZA',
			 modal:
			 [
				 {
					//  thumbnail: '/assets/images/main-page/modal/desk/robustez-e-seguranca.jpg',
					 tabName: 'aba 1',
					 caption: 'ROBUSTEZ<br>Y CONFIANZA',
					 title: 'MIRÁ EL MUNDO DESDE ARRIBA.',
					 description: 'La FIAT Strada es más robusta, con un <span>despeje del suelo de 214 mm</span> y un <span>ángulo de entrada de 24º</span>. Ahora cuenta con el <span>sistema E-locker</span>, que distribuye la potencia del motor entre las ruedas del vehículo para ayudarte a sobrepasar cualquier obstáculo. Esto sumado al sistema de suspensión mejorado, hacen a FIAT Strada aún más eficiente y más confortable.',
					 descriptionMobile: 'La FIAT Strada es más robusta, con un <span>despeje del suelo de 214 mm</span> y un <span>ángulo de entrada de 24º</span>. Ahora cuenta con el <span>sistema E-locker</span>, que distribuye la potencia del motor entre las ruedas del vehículo para ayudarte a sobrepasar cualquier obstáculo. Esto sumado al sistema de suspensión mejorado, hacen a FIAT Strada aún más eficiente y más confortable.',
					 video:'https://vimeo.com/431873640',// produção
					 // video:'https://vimeo.com/163406888',// mock
					 poster:
					 {
						 alt: '',
						 sources: [
					 		 {
								 media: '(max-width: 1024px) and (orientation: portrait)',
								 srcSet: '/assets/images/main-page/modal/desk/robustez-e-seguranca.jpg',
							 },
							 {
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/robustez-e-seguranca.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/robustez-e-seguranca.jpg',
							},
						],
					},
				},
			],
			thumb:
			{
				alt: 'robustez-e-seguranca',
				src: '/assets/images/main-page/thumbs/robustez-e-seguranca.jpg',
				srcSet: ['/assets/images/main-page/thumbs/robustez-e-seguranca.jpg', '/assets/images/main-page/thumbs/robustez-e-seguranca.jpg', '/assets/images/main-page/thumbs/robustez-e-seguranca.jpg'],
			},
		},
		{
			id: '#index',
			path: '/seguridad',
			title: 'MÁS<br>SEGURI-<br/>DAD',
			modal:
			[
				{
					thumbnail: '/assets/images/main-page/modal/desk/robustez-e-seguranca.jpg',
					tabName: 'aba 1',
					caption: 'MÁS<br> SEGURIDAD',
					title: 'MENOS PREOCUPACIONES PARA QUE DISFRUTES MÁS DEL VIAJE',
					description: 'La FIAT Strada cuenta con la tecnología de <span>control de estabilidad</span>, que mantiene la dirección incluso en las curvas más pronunciadas. Está también equipada con <span>bolsas de aire laterales</span>, para brindar aún más seguridad a todos los pasajeros.',
					descriptionMobile: 'La FIAT Strada cuenta con la tecnología de <span>control de estabilidad</span>, que mantiene la dirección incluso en las curvas más pronunciadas. Está también equipada con <span>bolsas de aire laterales</span>, para brindar aún más seguridad a todos los pasajeros.',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/seguranca.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/seguranca-desk.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/seguranca-desk.jpg',
							},
						],
					},
				},
			],
			thumb:
			{
				alt: 'muita-seguranca',
				src: '/assets/images/main-page/thumbs/eguranca.jpg',
				srcSet: ['/assets/images/main-page/thumbs/seguranca.jpg', '/assets/images/main-page/thumbs/seguranca.jpg', '/assets/images/main-page/thumbs/seguranca.jpg'],
			},
		},


		{
			id: '#index',
			path: '/tecnologia',
			title: 'CONFORT <br>Y TECNO-<br>LOGÍA&nbsp;',
			modal:
			[
				{
					thumbnail: '/assets/images/main-page/modal/desk/conforto-e-tecnologia.jpg',
					tabName: 'aba 1',
					caption: 'CONFORT <br>Y TECNOLOGÍA&nbsp;',
					title: 'CONDUCIR AHORA ES MÁS PLACENTERO',
					description: 'La FIAT Strada Volcano ahora es más moderna, porque está equipada con una <span>central multimedia de 7”</span> que se <span>conecta a tu teléfono de forma inalámbrica</span> para que disfrutes durante	todo el viaje. Ahora también es más cómoda,	porque cuenta con <span>dirección eléctrica</span> y <span>tapizados en cuero</span> con tela. Todo un cambio, ¿no?',
					descriptionMobile: 'La FIAT Strada Volcano ahora es más moderna, porque está equipada con una <span>central multimedia de 7”</span> que se <span>conecta a tu teléfono de forma inalámbrica</span> para que disfrutes durante	todo el viaje. Ahora también es más cómoda,	porque cuenta con <span>dirección eléctrica</span> y <span>tapizados en cuero</span> con tela. Todo un cambio, ¿no?',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/conforto-e-tecnologia.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/conforto-e-tecnologia.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/conforto-e-tecnologia.jpg',
							},
						],
					}
				},
			],
			thumb:
			{
				alt: 'confort y tecnologia',
				src: '/assets/images/main-page/thumbs/conforto-e-tecnologia.jpg',
				srcSet: ['/assets/images/main-page/thumbs/conforto-e-tecnologia.jpg', '/assets/images/main-page/thumbs/conforto-e-tecnologia.jpg', '/assets/images/main-page/thumbs/conforto-e-tecnologia.jpg'],
			},
		},
		{
			id: '#index',
			path: '/diseno',
			title: 'NUEVO<br/>DISEÑO<br/>&nbsp;<br/>&nbsp;',
			modal:
			[
				{
					thumbnail: '/assets/images/main-page/modal/desk/novo-design.jpg',
					tabName: 'aba 1',
					caption: 'NUEVO<br/>DISEÑO<br/>&nbsp;<br/>&nbsp;',
					title: 'LA ELEGANCIA ITALIANA SE FUNDE CON LA PASIÓN ARGENTINA.',
					//
					description: 'La Fiat Strada se renueva con un diseño que mezcla emoción y funcionalidad. El modelo será el primero de la marca Fiat en incluir el <span>nuevo isologo</span> en la parrilla delantera y el Fiat <span>Flag ////</span> en los detalles del vehículo. Esto sin contar los nuevos <span>faros LED, las llantas de 15" diamantadas</span> y todos los detalles que complementan su figura.',
					descriptionMobile:'La Fiat Strada se renueva con un diseño que mezcla emoción y funcionalidad. El modelo será el primero de la marca Fiat en incluir el <span>nuevo isologo</span> en la parrilla delantera y el Fiat <span>Flag ////</span> en los detalles del vehículo. Esto sin contar los nuevos <span>faros LED, las llantas de 15" diamantadas</span> y todos los detalles que complementan su figura.',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/novo-design.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/novo-design.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/novo-design.jpg',
							},
						],
					}
				},
				{
					thumbnail: '/assets/images/main-page/gallery/novo-design/imagem-2.jpg',
					tabName: 'aba 1',
					caption: 'NUEVO<br/>DISEÑO<br/>&nbsp;<br/>&nbsp;',
					title: 'LA ELEGANCIA ITALIANA SE FUNDE CON LA PASIÓN ARGENTINA.',
					//
					description: 'La Fiat Strada se renueva con un diseño que mezcla emoción y funcionalidad. El modelo será el primero de la marca Fiat en incluir el <span>nuevo isologo</span> en la parrilla delantera y el Fiat <span>Flag ////</span> en los detalles del vehículo. Esto sin contar los nuevos <span>faros LED, las llantas de 15" diamantadas</span> y todos los detalles que complementan su figura.',
					descriptionMobile:'La Fiat Strada se renueva con un diseño que mezcla emoción y funcionalidad. El modelo será el primero de la marca Fiat en incluir el <span>nuevo isologo</span> en la parrilla delantera y el Fiat <span>Flag ////</span> en los detalles del vehículo. Esto sin contar los nuevos <span>faros LED, las llantas de 15" diamantadas</span> y todos los detalles que complementan su figura.',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/novo-design-2.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/novo-design/imagem-2.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/novo-design/imagem-2.jpg',
							},
						],
					}
				},
				{
					thumbnail: '/assets/images/main-page/gallery/novo-design/imagem-3.jpg',
					tabName: 'aba 1',
					caption: 'NUEVO<br/>DISEÑO<br/>&nbsp;<br/>&nbsp;',
					title: 'LA ELEGANCIA ITALIANA SE FUNDE CON LA PASIÓN ARGENTINA.',
					//
					description: 'La Fiat Strada se renueva con un diseño que mezcla emoción y funcionalidad. El modelo será el primero de la marca Fiat en incluir el <span>nuevo isologo</span> en la parrilla delantera y el Fiat <span>Flag ////</span> en los detalles del vehículo. Esto sin contar los nuevos <span>faros LED, las llantas de 15" diamantadas</span> y todos los detalles que complementan su figura.',
					descriptionMobile:'La Fiat Strada se renueva con un diseño que mezcla emoción y funcionalidad. El modelo será el primero de la marca Fiat en incluir el <span>nuevo isologo</span> en la parrilla delantera y el Fiat <span>Flag ////</span> en los detalles del vehículo. Esto sin contar los nuevos <span>faros LED, las llantas de 15" diamantadas</span> y todos los detalles que complementan su figura.',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/novo-design-3.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/novo-design/imagem-3.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/novo-design/imagem-3.jpg',
							},
						],
					}
				},
				{
					thumbnail: '/assets/images/main-page/gallery/novo-design/imagem-4.jpg',
					tabName: 'aba 1',
					caption: 'NUEVO<br/>DISEÑO<br/>&nbsp;<br/>&nbsp;',
					title: 'LA ELEGANCIA ITALIANA SE FUNDE CON LA PASIÓN ARGENTINA.',
					//
					description: 'La Fiat Strada se renueva con un diseño que mezcla emoción y funcionalidad. El modelo será el primero de la marca Fiat en incluir el <span>nuevo isologo</span> en la parrilla delantera y el Fiat <span>Flag ////</span> en los detalles del vehículo. Esto sin contar los nuevos <span>faros LED, las llantas de 15" diamantadas</span> y todos los detalles que complementan su figura.',
					descriptionMobile:'La Fiat Strada se renueva con un diseño que mezcla emoción y funcionalidad. El modelo será el primero de la marca Fiat en incluir el <span>nuevo isologo</span> en la parrilla delantera y el Fiat <span>Flag ////</span> en los detalles del vehículo. Esto sin contar los nuevos <span>faros LED, las llantas de 15" diamantadas</span> y todos los detalles que complementan su figura.',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/novo-design-4.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/novo-design/imagem-4.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/novo-design/imagem-4.jpg',
							},
						],
					}
				},
			],
			thumb:
			{
				alt: 'nuevo diseño',
				src: '/assets/images/main-page/thumbs/novo-design.jpg',
				srcSet: ['/assets/images/main-page/thumbs/novo-design.jpg', '/assets/images/main-page/thumbs/novo-design.jpg', '/assets/images/main-page/thumbs/novo-design.jpg'],
			},
		},
		{
			id: '#index',
			path: '/espacio-interno',
			title: 'ESPACIO<br/>INTERNO<br/>&nbsp;',
			modal:
			[
				{
					thumbnail: '/assets/images/main-page/modal/desk/espaco-interno.jpg',
					tabName: 'aba 1',
					caption: 'ESPACIO<br/>INTERNO<br/>&nbsp;',
					title: 'DENTRO DE LA FIAT STRADA EL TAMAÑO ES UN HECHO.',
					description: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para 5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					descriptionMobile: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para 5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/espaco-interno.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/espaco-interno.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/modal/desk/espaco-interno.jpg',
							},
						],

					}
				},
				{
					thumbnail: '/assets/images/main-page/gallery/espaco-interno/imagem-2.jpg',
					tabName: 'aba 1',
					caption: 'ESPACIO<br/>INTERNO<br/>&nbsp;',
					title: 'DENTRO DE LA FIAT STRADA EL TAMAÑO ES UN HECHO.',
					description: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para 5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					descriptionMobile: 'Reinventamos FIAT Strada y creamos <span>la primera	cabina doble en la categoría con 4 puertas para	5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/espaco-interno-2.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/espaco-interno/imagem-2.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/espaco-interno/imagem-2.jpg',
							},
						],

					}
				},
				{
					thumbnail: '/assets/images/main-page/gallery/espaco-interno/imagem-3.jpg',
					tabName: 'aba 1',
					caption: 'ESPACIO<br/>INTERNO<br/>&nbsp;',
					title: 'DENTRO DE LA FIAT STRADA EL TAMAÑO ES UN HECHO.',
					description: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para 5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					descriptionMobile: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para	5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/espaco-interno-3.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/espaco-interno/imagem-3.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/espaco-interno/imagem-3.jpg',
							},
						],

					}
				},
				{
					thumbnail: '/assets/images/main-page/gallery/espaco-interno/imagem-4.jpg',
					tabName: 'aba 1',
					caption: 'ESPACIO<br/>INTERNO<br/>&nbsp;',
					title: 'DENTRO DE LA FIAT STRADA EL TAMAÑO ES UN HECHO.',
					description: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para 5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					descriptionMobile: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para	5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/espaco-interno-4.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/espaco-interno/imagem-4.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/espaco-interno/imagem-4.jpg',
							},
						],

					}
				},
				{
					thumbnail: '/assets/images/main-page/gallery/espaco-interno/imagem-5.jpg',
					tabName: 'aba 1',
					caption: 'ESPACIO<br/>INTERNO<br/>&nbsp;',
					title: 'DENTRO DE LA FIAT STRADA EL TAMAÑO ES UN HECHO.',
					description: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para 5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					descriptionMobile: 'Reinventamos FIAT Strada y creamos <span>la primera cabina doble en la categoría con 4 puertas para 5 pasajeros</span>. Sí, ¡esta es la primera camioneta de la categoría con espacio para tanta gente!',
					poster:
					{
						alt: '',
						sources: [
							{
								media: '(max-width: 1024px) and (orientation: portrait)',
								srcSet: '/assets/images/main-page/modal/mobile/espaco-interno-5.jpg',
							},
							{
								media: '(orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/espaco-interno/imagem-5.jpg',
							},
							{
								media: '(min-width: 1025px) and (orientation: landscape)',
								srcSet: '/assets/images/main-page/gallery/espaco-interno/imagem-5.jpg',
							},
						],

					}
				},
			],
			thumb:
			{
				alt: 'espacio interno',
				src: '/assets/images/main-page/thumbs/espaco-interno.jpg',
				srcSet: ['/assets/images/main-page/thumbs/espaco-interno.jpg', '/assets/images/main-page/thumbs/espaco-interno.jpg', '/assets/images/main-page/thumbs/espaco-interno.jpg'],
			},
		},
		
	],
};

export const safeId = (id, min = 0, max = data.features.length - 1) => {
	const current = parseInt(id, 10) || min;
	return clamp(current, min, max);
};

export const getAllPictures = () => {
	let pictures = [];
	data.features.forEach(item => {
		pictures = [...pictures, ...item.picture];
	});
	return pictures;
};

export const getAllThumbs = () => {
	let thumbs = [];
	data.features.forEach(item => {
		thumbs = [...thumbs, ...item.thumb];
	});
	return thumbs;
};

export const getAllInfo = () => {
	let info = [];
	data.features.forEach(item => {
		info = [...info, ...item.info];
	});
	return info;
};

export const getAllTitle = () => {
	let title = [];
	data.features.forEach(item => {
		title = [...title, ...item.title];
	});
	return title;
};

export const getAllPath = () => {
	let path = [];
	data.features.forEach(item => {
		path = [...path, ...item.path];
	});
	return path;
};

export const getAllId = () => {
	let id = [];
	data.features.forEach(item => {
		id = [...id, ...item.id];
	});
	return id;
};

export const getArgByInfoTitle = infoId4search => {
	for (let idx = 0; idx < data.features.length; idx += 1) {
		const info = data.features[idx].info.find(item => item.title === infoId4search);
		if (info) return data.features[idx];
	}
	return null;
};

export const getArgById = id2find => {
	id2find = safeId(id2find);
	return data.features.find((arg, index) => {
		const argId = /\#index/.test(arg.id) ? index : arg.id;
		return argId === id2find;
	});
};

export const getArgByPath = (path2find) => {
	return data.features.find((item) => {
		return item.path === path2find;
	});
};

export const getArgByTitle = (title2find) => {
	return data.features.find((item) => {
		return item.title === title2find;
	});
};

export const orderByClusterOrder = (order) => {
	return order.reduce((args, item) => {
		let feature = data.features[item];
		if (feature) {
			args.push(feature);
			return args;
		}
		if (isString(item)) {
			feature = item.charAt(0) === '/' ? getArgByPath(item) : getArgByTitle(item);
			if (feature) {
				args.push(feature);
				return args;
			}
		}
		throw new Error(`data-cover-error: O índice "${item}" não existe em data.features!`);
	}, []);
};

export default data;
